import { activationCodeField, defaultSignUpFields, linkedInField } from './questions.shared';
import { OnboardingQuestion } from '../onboarding.types';

type AdultQuestionKey = 'WHAT_BRINGS_YOU_HERE' | 'CREATE_ACCOUNT' | 'ENGAGE_IN_NETWORKS';

export const ADULT_QUESTIONS = (): Record<AdultQuestionKey, OnboardingQuestion> => {
  return {
    WHAT_BRINGS_YOU_HERE: {
      title: 'What brings you here?',
      subTitle: 'This helps us personalize your experience.',
      featuredIcon: 'Target04',
      onComplete: 'CONTINUE_WITHOUT_SUBMIT',

      question: {
        type: 'RADIO',

        profile_option_category_id: 'onboarding',
        profile_option_question_id: 'what_brings_you_here',
        profile_option_source: 'onboarding',

        rules: {
          required: 'Please select an option',
        },
        post_type: 'PROFILE_OPTION_ANSWER',
        options: [
          {
            label: 'I’m a current or retired professional and want to pay it forward',
            value: 'adult_professional_pay_it_forward',
          },
          {
            label: 'I am parent, guardian, or loved one of a young adult I support',
            value: 'adult_parent_guardian_loved_one',
          },
          {
            label: 'I’m volunteering through an employer, university, nonprofit',
            value: 'adult_volunteering',
          },
        ],
      },
    },
    CREATE_ACCOUNT: {
      title: 'Create your account',
      subTitle: 'Sign up in less than 2 minutes.',
      onComplete: 'SUBMIT_USER_INFO',
      featuredIcon: 'UserCircle',
      question: {
        type: 'FORM',
        fields: defaultSignUpFields,
      },
    },
    ENGAGE_IN_NETWORKS: {
      title: 'Engage in networks',
      subTitle:
        'Share a little about yourself so we can add you to Networks with students you can support.',
      featuredIcon: 'Dataflow01',
      onComplete: 'POST_PROFILE_OPTION_ANSWER',
      question: {
        type: 'FORM',
        fields: [
          {
            name: 'zip_code',
            placeholder: 'Enter your zip code',
            type: 'text',
            rules: {
              required: 'Zip code is required',
            },
            post_type: 'PROFILE_OPTION_ANSWER',
            profile_option_category_id: 'identity',
            profile_option_question_id: 'zip_code',
          },
          {
            name: 'CAREER_PATH_DROPDOWNS',
            type: 'text',
            profile_option_category_id: 'career',
            profile_option_question_id: 'career_fields',

            profile_option_option_id: 'career_fields',
            profile_option_suboption_id: 'What subcategory?',
          },
          activationCodeField,
          linkedInField,
        ],
      },
    },
  };
};

export const QUESTION_INDEX_TO_FIELDS_ADULT: Record<number, string[]> = {
  0: ['what_brings_you_here'], // WHAT_BRINGS_YOU_HERE
  1: ['first_name', 'last_name', 'phone', 'email', 'password'], // CREATE_ACCOUNT
  2: ['zip_code', 'career_path_category', 'career_path_subcategory', 'invite_code', 'linkedin_url'], // ENGAGE_IN_NETWORKS
};
